import React, { useState } from "react";
import PropTypes from "prop-types";
import UrgencySignalWrapper from "../urgency-signal/wrapper";
import Pill from "./pill";

const SizePills = ({ onSelect, skus, availability, availabilityLoaded, availabilityError }) => {
  const [selectedSize, setSelectedSize] = useState(null);

  const handleSelect = size => {
    setSelectedSize(size);
    if (onSelect) onSelect(size);
  };

  // Autoselect if oneSize product
  if (Array.isArray(skus) && skus.length === 1 && skus[0].sizeDisplayText === "One Size" && !selectedSize) {
    handleSelect(skus[0]);
  }

  return (
    <>
      <div className="mt-8 mb-3 flex justify-between">
        <span className="font-medium">Size:</span> {selectedSize?.sizeDisplayText}
        <UrgencySignalWrapper selectedSku={selectedSize?.sku} availability={availability} />
        <p>{availabilityError}</p>
      </div>

      <div className="flex flex-wrap gap-3">
        {skus?.map(size => (
          <Pill
            key={size?.sku}
            availabilityLoaded={!!availabilityLoaded}
            availability={availability}
            sizeToRender={size}
            selectedSize={selectedSize}
            handleSelect={handleSelect}
          />
        ))}
      </div>
    </>
  );
};

SizePills.propTypes = {
  onSelect: PropTypes.func,
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      sku: PropTypes.string,
      sizeDisplayText: PropTypes.string,
    })
  ).isRequired,
  availability: PropTypes.arrayOf(
    PropTypes.shape({
      sku: PropTypes.string,
      availableCount: PropTypes.number,
    })
  ).isRequired,
  availabilityLoaded: PropTypes.bool,
  availabilityError: PropTypes.string,
};

export default SizePills;
